<template>
  <div id="app">
    <Map/>
  </div>
</template>

<script>
import './utils';
import Map from "./components/Map";
export default {
  name: 'App',
  components: {
    Map
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  background: rgb(52, 55, 63);
  margin: 0;
  padding: 0;
}
</style>
